var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhosMyShopperFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_782_20869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3381 79.7578H63.7818M36.6714 79.7578H37.1151",
    stroke: "currentColor",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1123 1.98439H11.4227C12.3134 1.98243 13.184 2.24853 13.9214 2.7481C14.6587 3.24766 15.2287 3.95756 15.5571 4.78545L32.2227 46.4281L26.5352 57.7625C26.1934 58.4424 26.0319 59.1987 26.066 59.9589C26.1002 60.7192 26.3289 61.4579 26.7303 62.1044C27.1317 62.751 27.6924 63.2836 28.3586 63.6515C29.0248 64.0193 29.7742 64.2099 30.5352 64.2052H72.2227",
    stroke: "url(#paint0_linear_782_20869)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7789 15.3203H81.1123L68.6685 46.4307H32.2227",
    stroke: "url(#paint1_linear_782_20869)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_782_20869",
    x1: 72.2227,
    y1: 37.1541,
    x2: 16.0518,
    y2: 64.1638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E26C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_782_20869",
    x1: 81.1123,
    y1: 32.9052,
    x2: 45.7752,
    y2: 62.2163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E26C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_782_20869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhosMyShopperFilled);
export default __webpack_public_path__ + "static/media/whos-my-shopper-filled.ac32c141f2f747accf7fed93f5fa18f3.svg";
export { ForwardRef as ReactComponent };